import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=28358400"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28358400')) {
      api.createRecord('28358400', component.options)
    } else {
      api.reload('28358400', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=28358400", function () {
      api.rerender('28358400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/components/Sidebar/Link.vue"
export default component.exports